import React from 'react'
import { ComingSoon } from '@/components/common/ComingSoon'

const ReportsPage = () => {
  return (
    <ComingSoon 
      title="Financial Reports"
      description="Trial balance, P&L, balance sheet, and aging reports"
    />
  )
}

export default ReportsPage
